module.exports = __webpack_public_path__ + "static/media/nexo2.2481x200.29d32aae.png";